// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__WULF7","large":"styles_large__1DnyN"};